//import orderStatusApi from './dev'; // dev
import orderStatusApi from './prod'; // prod

export default orderStatusApi;
